import React from 'react'

const Loading = () => (

  <div>Logging you in...</div>
)

Loading.propTypes = {
}

export default Loading



// WEBPACK FOOTER //
// ./src/molecules/components/Loading.js